// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_cognito_identity_pool_id': 'us-east-1:9992066a-022d-49e9-91ec-4c049b8d2ad8',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'teacherreportingtool-hosting-mobilehub-1959554656',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'de4n9osbtbwix.cloudfront.net',
    'aws_dynamodb': 'enable',
    'aws_dynamodb_all_tables_region': 'us-east-1',
    'aws_dynamodb_table_schemas': [{"tableName":"teacherreportingtool-mobilehub-1959554656-Students","attributes":[{"name":"id","type":"S"}],"indexes":[],"region":"us-east-1","hashKey":"id"},{"tableName":"teacherreportingtool-mobilehub-1959554656-Users","attributes":[{"name":"id","type":"S"}],"indexes":[],"region":"us-east-1","hashKey":"id"}],
    'aws_project_id': '2792fcb6-aeac-47ce-8cf1-9bc215ac2e90',
    'aws_project_name': 'Teacher Reporting Tool',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'teacherreportingtool-mobilehub-1959554656',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_KtXKy024Y',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '4q63kdrso52rgf7hi2nisu374d',
}

export default awsmobile;
